// Packages:
import styled from 'styled-components';

// Exports:
export const Wrapper = styled.div`
  max-width: 100%;
`;
